import { render, staticRenderFns } from "./CustomFieldSection.vue?vue&type=template&id=0328b70a&scoped=true&"
import script from "./CustomFieldSection.vue?vue&type=script&lang=js&"
export * from "./CustomFieldSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldSection.vue?vue&type=style&index=0&id=0328b70a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0328b70a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VSelect,VTextField})
